import { chain } from '@leprecoins/effector';
import { sample } from 'effector';
import { debounce } from 'patronum';
import { createExportReportAccountsModel } from 'features/export-report-accounts';
import { accountTreeModel, createAccountReportRegistryModel } from 'entities/account';

export const accountReportRegistryModel = createAccountReportRegistryModel({});

const exportReportAccountsModel = createExportReportAccountsModel(accountReportRegistryModel);

sample({
	clock: debounce(accountTreeModel.$selectedNodes, 300),
	target: accountReportRegistryModel.model.filters.accountIds.setValue,
});

chain(accountReportRegistryModel.model.clearFilters, accountTreeModel.clearSelectedNodes);

export const accountsReportPageModel = { accountReportRegistryModel, exportReportAccountsModel };
